import axios from 'axios'
export default {
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/mixin/global.js